class RegulatoryDamageService {
    get_data(page, data) {
        return axios.post('general/readiness_report_issues?page=' + page, data)
    }
    get(id) {
        return axios.get('general/readiness_report_issues/' + id)
    }
    add(data) {
        return axios.post('general/readiness_report_issues/store', data)
    }
    edit(data) {
        return axios.post('general/readiness_report_issues/update', data)
    }
    delete(id) {
        return axios.post('general/readiness_report_issues/delete/' + id)
    }

}
export default new RegulatoryDamageService();